import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import HoneybadgerVue from '@honeybadger-io/vue'

const $http = axios.create({
  baseURL: location.protocol+"//"+location.hostname+"/api", //prod on STEBIO plesk
  // baseURL: location.protocol+"//"+location.hostname+":3000/api", //dev
})

// const config = {
//   apiKey: 'hbp_jBpNVRfA7jwJtlXDATDces83hv2AnG1lAZjB',
//   environment: 'production'
// }

const app = createApp(App)
app.use(router)
app.use(VueAxios, $http)
// app.use(HoneybadgerVue, config)

app.mount('#app')
